import store from '@/store'

// 检查权限
export function checkPower (power = 'view') {
  const userInfo = store.state.userModule.userMessage
  // const type = 'view'
  // const type = 'part_edit'
  const type = userInfo.operation_type
  if (power === 'view') return true
  if (!power || !userInfo) return false
  power = power.split(',')
  return power.includes(type)
}



// WEBPACK FOOTER //
// ./src/utils/checkPower.js